import styled, { keyframes } from 'styled-components'

export const Container = styled.div`
  display: grid;
  justify-content: center;
  align-items: center;
  /* height: 100px; */
`

const rotateSpinner = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`

export const Loading = styled.div`
  width: 50px;
  height: 50px;
  border: 2px solid #f3f3f3; /* Light grey */
  border-top: 2px solid #383636; /* Blue */
  border-radius: 50%;
  animation: ${rotateSpinner} 1s linear infinite;
`
